import { Box, Stack, Typography } from '@mui/material';
import { formatPrice } from '../../../utils/priceUtils';

const Fact = ({ label, value }) => (
  <Box sx={{ minWidth: 0 }}>
    <Typography
      sx={{
        fontSize: '10px',
        letterSpacing: '0.1em',
        textTransform: 'uppercase',
        color: '#999',
      }}
    >
      {label}
    </Typography>
    <Typography
      noWrap
      sx={{ fontSize: '13.5px', color: '#333', fontWeight: 600, fontVariantNumeric: 'tabular-nums' }}
    >
      {value}
    </Typography>
  </Box>
);

/**
 * The booked service inside a dashboard modal.
 *
 * Deliberately does not touch `displayConfig`: the dashboard is an internal tool with its own
 * neutral palette, and the tenant's accent colour on this surface reads as a stray. The guest
 * funnel's equivalent is `features/booking/components/SupplySummary`, which is themed.
 *
 * `booking`, when given, has the price the booking was made at: it wins over the supply's price of
 * today, and a coupon shows the price before it struck through, and the code, which is what the
 * counter needs to see.
 */
const SupplyDetails = ({ supply, booking }) => {
  if (!supply) return null;

  const price = booking?.price ?? supply.price;
  const priceValue = booking?.originalPrice != null
    ? (
      <>
        <Box component="s" sx={{ color: '#999', fontWeight: 400, mr: 0.75 }} data-testid="booking-original-price">
          {formatPrice(booking.originalPrice)}
        </Box>
        {formatPrice(price)}
      </>
    )
    : formatPrice(price);

  return (
    <Box
      sx={{
        border: '1px solid #e0e0e0',
        borderRadius: '6px',
        bgcolor: '#fafafa',
        px: 1.75,
        py: 1.5,
      }}
    >
      <Typography sx={{ fontSize: '14px', fontWeight: 700, color: '#222', mb: 1 }}>
        {supply.name}
      </Typography>

      <Stack direction="row" spacing={3}>
        <Fact label="Ár" value={priceValue} />
        <Fact label="Időtartam" value={`${supply.duration} perc`} />
        {booking?.couponCode && <Fact label="Kupon" value={booking.couponCode} />}
      </Stack>
    </Box>
  );
};

export default SupplyDetails;
